import Oidc from 'oidc-client';
//import config from '../../config';

var mgr = new Oidc.UserManager({
    authority: (config.VUE_APP_AUTH || process.env.VUE_APP_AUTH),
    client_id: 'vuestreamingweb',
    redirect_uri:(config.VUE_APP_BASE_URL || process.env.VUE_APP_BASE_URL) + '/callback',
    automaticSilentRenew: true,
    silent_redirect_uri: (config.VUE_APP_BASE_URL || process.env.VUE_APP_BASE_URL) + '/static/silent-renew.html',
    accessTokenExpiringNotificationTime: 10,
    response_type: 'code',
    scope: 'openid profile api_query.full_access streaming_api.full_access',
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
})

Oidc.Log.logger = console;

export default mgr;